import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import GlobalAdminDashboard from './GlobalAdminDashboard';
import AdminDashboard from './AdminDashboard';
import DirectionDashboard from './DirectionDashboard';
import FinanceDashboard from './FinanceDashboard';
import OperationsDashboard from './OperationsDashboard';
import AchatsDashboard from './AchatsDashboard';

const CLIENT_DASHBOARDS = {
  admin:      AdminDashboard,
  direction:  DirectionDashboard,
  finance:    FinanceDashboard,
  operations: OperationsDashboard,
  achats:     AchatsDashboard,
};

export default function Dashboard() {
  const { user } = useAuth();

  if (user.company?.type === 'ADMIN') return <GlobalAdminDashboard />;

  const roleName = user.role?.name ?? user.role;
  const Component = CLIENT_DASHBOARDS[roleName];
  return Component ? <Component /> : null;
}
